import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./style.css";

const InternetStatus = () => {
  // hooks
  const { t } = useTranslation("documentTitle");

  // states
  const [internetStatus, setInternetStatus] = useState("");

  // functions
  window.addEventListener("online", () => {
    setInternetStatus("online");
  });

  window.addEventListener("offline", () => {
    setInternetStatus("offline");
  });

  // useEffects
  useEffect(() => {
    setTimeout(() => {
      if (internetStatus === "online") {
        setInternetStatus("");
      }
    }, 3000);
  }, [internetStatus]);

  return (
    <div
      className={`InternetStatus ${
        internetStatus === "online" && "InternetStatus_online"
      } ${internetStatus === "offline" && "InternetStatus_offline"}`}
    >
      {internetStatus === "online" && "back online"}
      {internetStatus === "offline" && "no internet connection"}
    </div>
  );
};

export default InternetStatus;
